import { useCallback, useEffect, useRef, useState } from "react";

function useElementHover() {
  const [hover, setHover] = useState(false);
  const elementRef = useRef<HTMLElement | null>();

  const activateHover = useCallback(() => setHover(true), []);
  const deactivateHover = useCallback(() => setHover(false), []);

  const toggleHover = useCallback(() => setHover((value) => !value), []);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    element.addEventListener("mouseenter", activateHover);
    element.addEventListener("mouseleave", deactivateHover);

    element.addEventListener("touchstart", toggleHover);

    return () => {
      element.removeEventListener("mouseenter", activateHover);
      element.removeEventListener("mouseleave", deactivateHover);
      element.removeEventListener("touchstart", toggleHover);
    };
  }, [activateHover, deactivateHover, elementRef, toggleHover]);

  return { hover, elementRef };
}

export default useElementHover;
